var __hasProp = {}.hasOwnProperty;

define(['jquery', 'underscore'], function($, _) {
  var CacheManager;
  CacheManager = (function() {

    CacheManager.prototype.cacheConfig = {
      currency: {
        key: 'bench_cache_currency',
        ttl: 30 * 24 * 60 * 60 * 1000,
        refreshThreshold: 24 * 60 * 60 * 1000
      },
      country: {
        key: 'bench_cache_country',
        ttl: 30 * 24 * 60 * 60 * 1000,
        refreshThreshold: 24 * 60 * 60 * 1000
      },
      region: {
        key: 'bench_cache_region',
        ttl: 30 * 24 * 60 * 60 * 1000,
        refreshThreshold: 24 * 60 * 60 * 1000
      },
      ledgerAccountCategory: {
        key: 'bench_cache_ledger_account_category',
        ttl: 30 * 24 * 60 * 60 * 1000,
        refreshThreshold: 24 * 60 * 60 * 1000
      }
    };

    function CacheManager() {
      this.storage = window.localStorage;
    }

    CacheManager.prototype.getCacheKey = function(type, clientId) {
      var config, key;
      if (clientId == null) {
        clientId = null;
      }
      config = this.cacheConfig[type];
      if (!config) {
        return null;
      }
      key = config.key;
      if (clientId) {
        key += "_" + clientId;
      }
      return key;
    };

    CacheManager.prototype.getFromCache = function(type, clientId) {
      var cached, config, data, key, now;
      if (clientId == null) {
        clientId = null;
      }
      try {
        key = this.getCacheKey(type, clientId);
        if (!key) {
          return null;
        }
        cached = this.storage.getItem(key);
        if (!cached) {
          return null;
        }
        data = JSON.parse(cached);
        now = Date.now();
        config = this.cacheConfig[type];
        if (data.timestamp && (now - data.timestamp) < config.ttl) {
          return data.value;
        } else {
          this.storage.removeItem(key);
          return null;
        }
      } catch (e) {
        console.warn("Cache read error for " + type + ":", e);
        return null;
      }
    };

    CacheManager.prototype.saveToCache = function(type, data, clientId) {
      var cacheData, key;
      if (clientId == null) {
        clientId = null;
      }
      try {
        key = this.getCacheKey(type, clientId);
        if (!key) {
          return;
        }
        cacheData = {
          value: data,
          timestamp: Date.now()
        };
        return this.storage.setItem(key, JSON.stringify(cacheData));
      } catch (e) {
        console.warn("Cache write error for " + type + ":", e);
        return this.clearOldestCache();
      }
    };

    CacheManager.prototype.clearOldestCache = function() {
      var cached, config, data, key, oldest, oldestTime, type, _ref;
      try {
        oldest = null;
        oldestTime = Infinity;
        _ref = this.cacheConfig;
        for (type in _ref) {
          if (!__hasProp.call(_ref, type)) continue;
          config = _ref[type];
          key = config.key;
          cached = this.storage.getItem(key);
          if (!cached) {
            continue;
          }
          data = JSON.parse(cached);
          if (data.timestamp < oldestTime) {
            oldestTime = data.timestamp;
            oldest = key;
          }
        }
        if (oldest) {
          return this.storage.removeItem(oldest);
        }
      } catch (e) {
        return console.warn("Error clearing old cache:", e);
      }
    };

    CacheManager.prototype.clearAllCache = function() {
      var config, key, type, _ref, _results;
      _ref = this.cacheConfig;
      _results = [];
      for (type in _ref) {
        if (!__hasProp.call(_ref, type)) continue;
        config = _ref[type];
        try {
          this.storage.removeItem(config.key);
          _results.push((function() {
            var _i, _len, _ref1, _results1;
            _ref1 = Object.keys(this.storage);
            _results1 = [];
            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
              key = _ref1[_i];
              if (key.startsWith(config.key + "_")) {
                _results1.push(this.storage.removeItem(key));
              } else {
                _results1.push(void 0);
              }
            }
            return _results1;
          }).call(this));
        } catch (e) {
          _results.push(console.warn("Error clearing cache for " + type + ":", e));
        }
      }
      return _results;
    };

    CacheManager.prototype.shouldRefreshCache = function(type, clientId) {
      var cached, config, data, key, now;
      if (clientId == null) {
        clientId = null;
      }
      try {
        key = this.getCacheKey(type, clientId);
        if (!key) {
          return true;
        }
        cached = this.storage.getItem(key);
        if (!cached) {
          return true;
        }
        data = JSON.parse(cached);
        now = Date.now();
        config = this.cacheConfig[type];
        return (now - data.timestamp) > config.refreshThreshold;
      } catch (e) {
        return true;
      }
    };

    CacheManager.prototype.wrapFetch = function(collection, cacheType, clientId) {
      var manager, originalFetch;
      if (clientId == null) {
        clientId = null;
      }
      originalFetch = collection.fetch.bind(collection);
      manager = this;
      return collection.fetch = function(options) {
        var cachedData, deferred;
        if (options == null) {
          options = {};
        }
        deferred = $.Deferred();
        cachedData = manager.getFromCache(cacheType, clientId);
        if (cachedData) {
          collection.reset(cachedData);
          deferred.resolve(cachedData);
          if (manager.shouldRefreshCache(cacheType, clientId)) {
            originalFetch(options).done(function(freshData) {
              manager.saveToCache(cacheType, freshData, clientId);
              if (!_.isEqual(cachedData, freshData)) {
                collection.reset(freshData);
                return collection.trigger('cache:updated', freshData);
              }
            });
          }
        } else {
          originalFetch(options).done(function(data) {
            manager.saveToCache(cacheType, data, clientId);
            return deferred.resolve(data);
          }).fail(function(xhr, status, error) {
            return deferred.reject(xhr, status, error);
          });
        }
        return deferred.promise();
      };
    };

    return CacheManager;

  })();
  return new CacheManager();
});
